import { apiRequest } from '../api/http'

export interface SallaInvitationPreview {
  storeName: string
  merchantId: string
  organizationId: number
}

export function previewSallaInvitation(accessToken: string, token: string): Promise<SallaInvitationPreview> {
  return apiRequest('/api/channels/salla/invitations', '/preview', {
    method: 'POST', accessToken, body: { token },
  })
}

export function confirmSallaInvitation(accessToken: string, token: string, organizationId: number): Promise<{ connectionId: number }> {
  return apiRequest('/api/channels/salla/invitations', '/confirm', {
    method: 'POST', accessToken, body: { token, organizationId },
  })
}
